import Vehicle from "@/models/Vehicle";
import axiosHelper from "../axiosHelper";
import VehicleModel from "@/models/VehicleModel";

export default class VehicleApiHelper {

	_url: string = '/api/vehicles';

	async createAsync(jwt: string, request: any) : Promise<Vehicle | null> {
		try {
			const addOrderHttpClient = axiosHelper.createInstance(jwt);
			const response = await addOrderHttpClient.post(this._url, request);		
			if (!response.data?.id) {
				console.error('Unable to create vehicle: empty response');
				return null;
			}
			return new Vehicle(response.data);			
		} catch(e: any) {
			if (e?.status === 409) {
				console.error(`Unable to create vehicle: vin '${request.vin}' already exists`);
				return null;
			}

			console.error('Unable to create vehicle', e);
			return null;
		}
	}

	async updateAsync(jwt: string, request: any) : Promise<Vehicle | null> {
		try {
			const updateVehicleHttpClient = axiosHelper.createInstance(jwt);
			const response = await updateVehicleHttpClient.put(this._url, request);		
			if (!response.data?.id) {
				console.error('Unable to update vehicle: empty response');
				return null;
			}
			return new Vehicle(response.data);
		} catch(e: any) {
			if (e?.status === 409) {
				console.error(`Unable to update vehicle: vin '${request.vin}' already exists`);
				return null;
			}

			console.error('Unable to update vehicle', e);
			return null;
		}
	}

	async getVehicleByIdAsync(jwt: string, id: number) : Promise<Vehicle | null>  {
		try {
			const checkVinHttpClient = axiosHelper.createInstance(jwt);
			const respone = await checkVinHttpClient.get(`${this._url}/id/${id}`);	
			if (!respone.data?.id) {
				return null;
			}
			return new Vehicle(respone.data);
		} catch(e) {
			console.error(`Unable to get vehicle by id #${id}`, e);
			return null;
		}
	}

	async getCounterpartyVehiclesAsync(jwt: string, counterpartyId: number) : Promise<Array<Vehicle> | null> {
		try {
			const response = await axiosHelper
				.createInstance(jwt)
				.get(`${this._url}/by-counterparty/${counterpartyId}`);

			if (!response?.data?.length) {
				return [];
			}

			return response.data.map((_: any) => new Vehicle(_));

		} catch(e: any) {
			console.error(`Unable to get counterparty #${counterpartyId} vehicles:`, e);
			return null;
		}
	}

	async deleteVehicleAsync(jwt: string, vehicleId: number) : Promise<boolean> {
		try {
			await axiosHelper.createInstance(jwt).delete(`${this._url}/${vehicleId}`);
			return true;
		} catch(e: any) {
			if (e?.status === 409) {
				return false;
			}
			console.error(`Unable to delete vehicle #${vehicleId}:`, e);
			return false;
		}
	}

	async getVehicleByVinAsync(jwt: string, vin: string) : Promise<VehicleModel | null>  {
		try {
			const checkVinHttpClient = axiosHelper.createInstance(jwt);
			const respone = await checkVinHttpClient.get(`/api/vehicles/vin/${vin}`);	
			if (!respone.data?.id) {
				return null;
			}
			return new VehicleModel(respone.data);
		} catch(e) {
			console.error(`Unable to get vehicle by vin '${vin}'`, e);
			return null;
		}
	}

	async decodeVinAsync(jwt: string, vin: string) : Promise<Vehicle | null> {
		try {
			const response = await axiosHelper.createInstance(jwt).post(`${this._url}/vin`, { vin });
			if (!response?.data) {
				return null;
			}
			return new Vehicle(response.data);
		} catch(e: any) {
			console.error(`Unable to decode VIN '${vin}':`, e);
			return null;
		}
	}
}
